import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetRequestTypeModel } from "@core/model/query-model-request-type";
import { requestTypeFormDefault } from "./form.default";
import { RequestTypeFormSchema } from "./form.rule";

export const useFormDefaultRequestType = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetRequestTypeModel | undefined) => {
    return !cachedValue
      ? requestTypeFormDefault
     : ({
        name: cachedValue.name,
        description: cachedValue.description,
      } as RequestTypeFormSchema);
  };

  return {
    getDefault,
  };
};
